import React, { Component } from "react";
import { connect } from "react-redux";

// React Bootstrap
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

import Logo from "../../images/logo.png";
import SignedInLinks from "./SignedInLinks";
import SignedOutLinks from "./SignedOutLinks";

const Topbar = props => {
  const { auth, profile } = props;
  const links = auth.uid ? <SignedInLinks profile={profile} /> : <SignedOutLinks />;
  return (
    <Navbar bg="light" expand="lg">
      <Navbar.Brand href="/">
        <img src={Logo} alt="logo" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto"></Nav>
        {links}
        <Nav.Link
          className="Topbar-link"
          target="_blank"
          href="https://japaninfoclients.netlify.com"
        >
          企業サイト
        </Nav.Link>
        <Nav.Link className="topbar-link" href="#home">
          ブログ
        </Nav.Link>
      </Navbar.Collapse>
    </Navbar>
  );
};

const mapStateToProps = state => {
  console.log(state);
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

export default connect(mapStateToProps)(Topbar);
